import React from "react";
import { SearchByResult } from "../redux/api-slice";
import { useAppSelector } from '../redux/hooks';


export default function ResultsCount() {
    const isInMaintenanceMode = useAppSelector((state) => state.pageSettings.isInMaintenanceMode);
    const isFetching = useAppSelector((state) => state.pageSettings.isSearching);
    const operaFilter = useAppSelector((state) => state.searchOptions.operaFilter);
    const searchResults = useAppSelector((state) => state.pageSettings.searchResults);

    const operaFilterResult = operaFilter
        ? (searchResults.results as Array<SearchByResult>).filter(result => result.operaTitle === operaFilter)[0]
        : null;

    return (
        <div className="results-counter h6-style">
            {
                (isFetching || isInMaintenanceMode || searchResults?.results?.length <= 0)
                    ? ""
                    : (operaFilter && operaFilterResult)
                        ? <>
                            {`${operaFilterResult.castResults.length} result(s) for `}
                            <span className="results-counter-opera">{operaFilter}</span>
                        </>
                        : `${searchResults.results.length} result(s)`
            }
        </div>
    );
}